import type { FaireProductEntity } from "../../entity_types/product";

export const apparel_socks_horse: FaireProductEntity = {
  token: "apparel-socks-horse",
  type: "product",
  name: "Horse Print Crew Socks",
  brandName: "Curated Basics",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/913008319b3ac99376eb0c53412f93674133e2e4ce70be383f773f80b8f19b9b.jpeg",
  priceDollars: 8,
  msrpDollars: 16,
  freeShipping: true,
  weight: 0.2,
  dimensions: {
    width: 4,
    height: 2,
    depth: 1,
  },
  description:
    "Playful horse-print crew socks. Available in black/cream and white/brown.",
  categoryTokens: ["cat_accessories"],
  tags: ["apparel", "socks", "novelty", "print"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
